module.exports = __webpack_public_path__ + "img/wxkzg.698f6a3b.png";